<!-- UpdateMlsCell.vue -->
<template>
  <div class="umc-cell">
    <button v-if="canShowUpdateButton" type="button" class="umc-btn umc-btn--primary" :title="updateTitle"
      @click="openModal">
      <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
        <path d="M3 3v5h5" />
        <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
        <path d="M16 21h5v-5" />
      </svg>
      <span>Update Rental</span>
    </button>

    <a v-if="openTab !== 'unitmixrental'" class="umc-btn umc-btn--ghost"
      :href="`https://www.realpropertydata.ca/backend/field-collection/field-mls-collection/${row.cid}/edit`"
      target="_blank" rel="noopener" title="Open admin editor in a new tab">
      <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
      </svg>
      <span>Edit</span>
    </a>

    <!-- MlsForm Modal (self-contained) -->
    <transition name="sp-fade">
      <MlsForm
        v-if="modalOpen"
        :mls-cid="row.cid"
        :mls-unit="row.mls_address"
        @fetchData="onFetchData"
        @close="modalOpen = false"
      />
    </transition>
  </div>
</template>

<script>
import MlsForm from "../Forms/MlsForm.vue";

export default {
  components: { MlsForm },
  props: {
    row: { type: Object, required: true },
    openTab: { type: String, default: "" },
    showFlag: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false },
    onUpdateMls: { type: Function, default: null },
    isMarketStrata: { type: Boolean, default: false }
  },
  data() {
    return { modalOpen: false };
  },
  computed: {
    canShowUpdateButton() {
      return (this.openTab !== 'unitmixrental' || this.showFlag || this.isAdmin) && this.isMarketStrata;
    },
    updateTitle() {
      return this.row.mls_address ? `Update rental — Unit ${this.row.mls_address}` : 'Update rental';
    }
  },
  methods: {
    openModal() {
      this.modalOpen = true;
    },
    onFetchData() {
      if (typeof this.onUpdateMls === 'function') {
        this.onUpdateMls({ cid: this.row.cid, unit: this.row.mls_address });
      }
    }
  }
};
</script>

<style>
.umc-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 4px;
}

.umc-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  font-family: var(--rpd-font-sans, "Inter Tight", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition:
    background 120ms cubic-bezier(0.2, 0, 0, 1),
    border-color 120ms cubic-bezier(0.2, 0, 0, 1),
    color 120ms cubic-bezier(0.2, 0, 0, 1),
    box-shadow 120ms cubic-bezier(0.2, 0, 0, 1);
}

.umc-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(52, 51, 118, 0.32);
}

.umc-btn svg {
  flex-shrink: 0;
}

.umc-btn--primary {
  background: var(--rpd-coral, #F26A6F);
  color: #ffffff;
  border-color: var(--rpd-coral, #F26A6F);
  box-shadow: 0 1px 2px rgba(217, 75, 82, 0.18);
}

.umc-btn--primary:hover {
  background: var(--rpd-coral-dark, #D94B52);
  border-color: var(--rpd-coral-dark, #D94B52);
  box-shadow: 0 2px 6px rgba(217, 75, 82, 0.24);
}

.umc-btn--primary:active {
  background: var(--rpd-coral-dark, #D94B52);
  border-color: var(--rpd-coral-dark, #D94B52);
  transform: translateY(1px);
}

.umc-btn--ghost {
  background: transparent;
  color: var(--rpd-ink, #0A1320);
  border-color: var(--rpd-line, #E3E8EF);
}

.umc-btn--ghost:hover {
  background: var(--rpd-line-2, #EFF2F6);
  border-color: #C9CCD2;
  color: var(--rpd-ink, #0A1320);
}

.umc-btn--ghost:active {
  background: var(--rpd-line, #E3E8EF);
}

html.dark .umc-btn--ghost {
  color: #E3E8EF;
  border-color: rgba(255, 255, 255, 0.18);
}

html.dark .umc-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.32);
  color: #ffffff;
}
</style>
